import React, { Component } from 'react';
import '../../../styles/supervise.scss';

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: '',
      defaultValue: sessionStorage.getItem('onlineCourseTour_classname') || '',
    };
    this.onPressHandler = this.onPressHandler.bind(this);
    this.onBlurHandler = this.onBlurHandler.bind(this);
  }
  componentDidMount() {
    if (this.state.defaultValue) {
      this.props.getClassroom();
    }
  }

  onPressHandler(e) {
    // console.log(e.key);
    if (e.key === 'Enter') {
      this.props.getClassroom();
    }
  }
  onBlurHandler() {
    this.props.getClassroom();
  }
  render() {
    return (
      <div className="supervise-search-input online-course-tour_search-input">
        <em className="supervise-search-input-icon" />
        <input
          ref={this.props.ref_classroom}
          className="fullHeight"
          type="text"
          defaultValue={this.state.defaultValue}
          placeholder="教室名称"
          onKeyPress={this.onPressHandler}
          onBlur={this.onBlurHandler}
        />
        {this.state.searchValue && (
          <span
            onClick={() => {
              // this.state.setSearchValue('');
              this.setState({
                searchValue: '',
              });
            }}
          >
            {/*<CloseIcon className={'supervise-search-input-close'} />*/}
          </span>
        )}
      </div>
    );
  }
}
export { SearchBar };
